module.exports = __webpack_public_path__ + "media/images/emblems/Biel-coat_of_arms-e08553f32ef7394b8bd9ff4b2b174be8.svg";